// extracted by css-extract-rspack-plugin
export default {"cls1":"ActiveState-cls1_uXW","cls2":"ActiveState-cls2_pZk ActiveState-cls1_uXW"};